import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage, useFormikContext } from 'formik';
import { hideLoading, showLoading } from '../../lib/uiService';
import HDBonusService from '../../services/hd.bonus.service';
import HDBonusForm from '../../components/Bonuses/HDBonusForm';
import useErrorHandling from '../../hooks/useErrorHandling';
import HDBonusTable from '../../components/HDBonus/HDBonusTable';

const HDBonusDetail: React.FC = () => {
  const [bonusData, setBonusData] = useState<any>({});
  const [answersData, setAnswersData] = useState<any>({});
  const { setError } = useErrorHandling();
  const { submissionId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (submissionId) {
      getHDBonus(submissionId);
    }
  }, [submissionId]);

  const getHDBonus = (id: any) => {
    showLoading();
    HDBonusService.GetHDBonusById(id)
      .then((res) => {
        const { data } = res;
        const answers = data?.answers || [];
        const answersData = {
          healthParticipation: answers.find((a: any) => a.questionId === 1)?.booleanValue || false,
          developmentParticipation: answers.find((a: any) => a.questionId === 2)?.booleanValue || false,
          bookTitle: answers.find((a: any) => a.questionId === 3)?.textValue || '',
          bookClubParticipation: answers.find((a: any) => a.questionId === 4)?.intValue || '',
          keyLearnings: answers.find((a: any) => a.questionId === 5)?.textValue || '',
          companyInsights: answers.find((a: any) => a.questionId === 6)?.textValue || '',
          interestTopics: answers.find((a: any) => a.questionId === 7)?.textValue || '',
          biggestTakeaway: answers.find((a: any) => a.questionId === 8)?.textValue || '',
          surprisingAnalogy: answers.find((a: any) => a.questionId === 9)?.textValue || '',
          recommendation: answers.find((a: any) => a.questionId === 10)?.textValue || '',
        };

        setBonusData(data);
        setAnswersData(answersData);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        setError(error.status);
      });
  };

  return (
    <>
      <h4 className="mb-2">
        H&D Submission for {[bonusData?.user?.firstName, bonusData?.user?.lastName].filter(Boolean).join(' ')}
      </h4>
      <HDBonusTable isAdmin={false} bonusHistory={[bonusData]} />
      <HDBonusForm
        key={Object.keys(answersData).length} // Force remount when bonusData changes
        bonusData={bonusData}
        answersData={answersData}
        onSubmissionSuccess={() => {}}
        isDisabled
      />
    </>
  );
};

export default HDBonusDetail;
